import {loadable} from 'router/routes';

const SmsPermissions = loadable(() => import('./SmsPermissions'));

export default SmsPermissions;
